import React, { PureComponent } from 'react';
import { Router, Route, browserHistory } from 'react-router';
import App from './App';
import ComponentIndexPage from '../pages/ComponentIndexPage';
import ComponentDetailPage from '../pages/ComponentDetailPage';
import MetricsPage from '../pages/MetricsPage';
import DependenciesPage from '../pages/DependenciesPage';
import { BASE_URL } from '../config';

export default class MainRouter extends PureComponent {
  render() {
    return (
      <Router history={browserHistory}>
        <Route component={App}>
          <Route path={`${BASE_URL}/`} component={ComponentIndexPage} />
          <Route path={`${BASE_URL}/:componentName/:componentVersion/index.html`} component={ComponentDetailPage} />
          <Route path={`${BASE_URL}/metrics.html`} component={MetricsPage} />
          <Route path={`${BASE_URL}/dependencies.html`} component={DependenciesPage} />
        </Route>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/MainRouter.jsx